<template>
  <v-card outlined max-width="100%" class="pt-12">
    <v-toolbar flat solo class="mt-n12">
      <v-toolbar-title class="mr-2">
        <h2 class="authorizer-title">{{title}} 
        </h2>
      </v-toolbar-title>
      <v-tooltip right>
      <template v-slot:activator="{ on, attrs }">
         <v-btn
          height="30px"
          width="30px" 
          color="primary"
          icon
          @click="verExtrato()"
          v-bind="attrs"
          v-on="on"
          >
            <v-icon small>fas fa-external-link-alt</v-icon>
          </v-btn>
        </template>
        <span class="px-3 py-1 ma-0" style="border: solid 1px #999; border-radius: 5px; background-color: #FFF;">
            {{tipo == "Autorizacao" ? "Extrato de autorizações" : "Extrato de transações"}}
          </span>
      </v-tooltip>
      <v-spacer></v-spacer>
      <v-toolbar-title class="pr-3">
        <h2 class="chart-pie-qtd">TOTAL: {{totalizador}}</h2>
      </v-toolbar-title>
    </v-toolbar>
    <chart :id="'chartPie'+tipo+periodo" :options="option" />
    <!-- <v-card-actions>
      <v-spacer></v-spacer>
      <v-btn
          height="30px" 
          color="primary"
          depressed
          text
          @click="verExtrato()"
          >
          <v-icon small left>fas fa-external-link-alt </v-icon>
            {{tipo == "Autorizacao" ? "Extrato de autorizações" : "Extrato de transações"}}</v-btn
          >
    </v-card-actions> -->
  </v-card>
</template>

<script>
import ECharts from "vue-echarts"
import echarts from "echarts"
import moment from "moment"
export default {
  components: {
    chart: ECharts,
  },
  data() {
    return {
      option: {},
      rotaDoExtrato: '',
      totalizador: null
    }
  },
  watch:{
    list(){
      this.formatChart()
    }
  },
  mounted() {
    this.rotaDoExtrato = this.tipo=="Autorizacao"?'/autorizacao/extratodeautorizacao' : '/autorizacao/extratodetransacao'
    this.formatChart()
  },
  methods: {
    formatChart() {
      //Iniciando variáveis
      let list = Array.from(this.list)
      let titles = [], colors = ["#D3DBDF"], series =[], fator_posicao, total = 0
      // let colorsList = ["#32B88B", "#B2B842", "#FC9D0A", "#FC5F17", "#D0021B", "#4A4A4A", "#979797"]
      let colorsList = ["#32b88b", "#b2b842", "#fc9d0a", "#fc5f17", "#d0021b", "#4a4a4a", "#979797"]

      total = list.reduce((soma, item) => soma + item.total, 0)
      fator_posicao = (100-16)/(this.categorias.length-1)
      this.categorias.forEach((el, ind) => {
        //calcular posição
        let pos = (fator_posicao*ind+7)+'%'
        // calcular total do item
        let totalCategoria = list.reduce((soma, item) => soma + item[el.parametro], 0)
        if(totalCategoria > 0){ colors.push(colorsList[ind])} 
        //calcular percentuais
        let perc = total > 0 ? (totalCategoria / total * 100).toFixed() : (0).toFixed() 
        titles.push({
            subtext: el.descricao + `\n\n${perc}%`,
            left: pos,
            top: "50%",
            textAlign: "center",
          })
        series.push({
            name: el.descricao,
            id: el.parametro,
            type: "pie",
            radius: ["36%", "40%"],
            center: [pos, "30%"],
            data: [
              { name: "", value: (total-totalCategoria) },
              { name: `${totalCategoria}`, value: totalCategoria },
            ],
            animation: true,
            label: {
              show: true,
              position: "center",
              fontSize: "20",
              color: "#455A65",
            }
          })
         
      })
      this.totalizador = total
      this.option = {
        title: titles,
        color: colors,
        series: series,
      }
        this['chartPie'+this.tipo+this.periodo] = echarts.init(document.getElementById(`chartPie${this.tipo}${this.periodo}`));
        this['chartPie'+this.tipo+this.periodo].on('click', (params) => this.verExtrato(params))  
    },
    verExtrato(params){
        let  data_inicio, data_final
        let periodo = this.periodo
        let status = params
        let referencedate = this.date
        if(periodo == 'dia'){
          data_inicio = referencedate? referencedate.split('T')[0] : null
          data_final = referencedate? referencedate.split('T')[0] : null
        } else {
          data_inicio = referencedate? moment(referencedate).startOf('month').format('YYYY-MM-DD') : null
          data_final = referencedate? moment(referencedate).endOf('month').format('YYYY-MM-DD') : null
        }
        let data = {status, data_inicio, data_final, periodo, rota: this.rotaDoExtrato}
        this.setFilter(data)
    }
  },
  props: {
    categorias: Array,
    date: String,
    list: Array,
    periodo: String,
    setFilter: Function,
    tipo: String,
    title: String,
    total: String,
  }
};
</script>

<style scoped>
.echarts {
  width: 100%;
  height: 150px;
}
.chart-pie-qtd {
  font-family: "system-ui";
  font-style: normal;
  font-weight: normal;
  font-size: 16px;
  line-height: 16px;
  color: #4a4a4a;
}
</style>